<template>
  <div>
    <div class="pop_ul scrollBar" ref="pop_ul">
      <div class="timeAll_w">
        <el-date-picker
          disabled
          v-model="value1"
          class="timeAll"
          type="daterange"
          @change="getlist"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-dropdown disabled @command="handleCommand" class="timeDow">
          <span
            class="el-dropdown-link"
            :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
          >
            {{ $t("Last days Days", { days: days })
            }}<i
              class="el-icon-caret-bottom el-icon--right"
              :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="7">{{
              $t("gps.num1")
            }}</el-dropdown-item>
            <el-dropdown-item command="30">{{
              $t("gps.num2")
            }}</el-dropdown-item>
            <el-dropdown-item command="60">{{
              $t("gps.num3")
            }}</el-dropdown-item>
            <el-dropdown-item command="90">{{
              $t("gps.num4")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="noData" v-if="list.length <= 0 && status">
        {{ $t("messages.no") }}
      </div>
      <div
        v-show="code > 0"
        :style="{
          'min-height': height,
          position: 'relative',
          'overflow-y': 'scroll',
          'overflow-x': 'hidden',
          'padding-bottom': '77px',
        }"
      >
        <div
          @click="getpop(val)"
          :class="pop.id == val.id ? 'pop_li mr' : 'pop_li'"
          v-for="(val, key) in list"
          :key="key"
        >
          <div class="pop_li_t">
            {{ val.name || val.mobile }}
            <span>{{ val.time }}</span>
          </div>
          <div class="pop_li_c">
            <span v-if="val.type == 1"> {{ val.msg }}</span>
            <span v-if="val.type == 2">[{{ $t("textphoto") }}]</span>
            <span v-if="val.type == 3">[{{ $t("textvideo") }}]</span>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            @current-change="setPage"
            background
            page-size="20"
            layout="prev, pager, next"
            :total="code"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div
      id="dialog"
      :style="{ width: bodyWidth - 681 + 'px', height: bodyHeight - 60 + 'px' }"
    >
      <div class="name">
        {{ pop.name }}
        <div class="time1">
          {{ pop.name === pop.mobile ? "" : pop.mobile }}
        </div>
      </div>

      <div
        class="dialog scrollBar"
        style="padding-bottom: 40px"
        ref="scrollBar"
        :style="{ height: bodyHeight - 139 - 40 + 'px' }"
      >
        <div v-for="(val, key) in chat" :key="key">
          <div :class="val.is_self == 2 ? 'user' : 'my'">
            <div :class="val.is_self == 2 ? 'user_img' : 'my_img'">
              <img
                :src="'https://apidemo.spylix.com/' + val.avatar"
                v-if="val.avatar"
              />
              <img
                v-else-if="val.is_self == 2"
                src="@/assets/img/my_avatar.png"
              />
              <img v-else src="@/assets/img/my_avatar.png" />
            </div>
            <div :class="val.is_self == 2 ? 'user_dialog' : 'my_dialog'">
              <div class="time">{{ val.time }}</div>
              <div class="content" v-if="val.type == 1">
                {{ val.msg }}
              </div>
              <div class="content" v-if="val.type == 2" style="line-height: 0">
                <el-image
                  :src="val.msg"
                  :preview-src-list="[val.msg]"
                  :initial-index="1"
                >
                </el-image>
                <div
                  style="
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    background-color: rgba(0, 0, 0, 0.5);
                    margin-top: 12px;
                    position: absolute;
                    bottom: 20px;
                    right: 20px;
                  "
                  @click="downloadFilePic(val.msg)"
                >
                  <i
                    class="el-icon-download"
                    style="color: #fff; font-size: 16px"
                  ></i>
                </div>
              </div>

              <div class="content" v-if="val.type == 3">
                <video
                  style="min-width: 380px; height: 150px"
                  class="video-js"
                  controls
                  preload="auto"
                  width="100%"
                  height="100%"
                  data-setup="{}"
                  muted
                >
                  <source :src="val.msg" type="video/mp4" />
                  <!-- <source src="https://d2dqy9cv20ceac.cloudfront.net/videos/5258DE9A19395591B7290DA7088B029A.mp4?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA3ORK4W5VLLQ4R5X7%2F20241116%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20241116T023604Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=054ac570b7e1179f38da6c1dd35aa8b811b7cdcb1b2a4a832330b64dd7f2515f" type="video/mp4" /> -->
                </video>

                <div
                  style="
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    background-color: rgba(0, 0, 0, 0.5);
                    margin-top: 12px;
                    position: relative;
                    left: 347px;
                  "
                  @click="downloadFilePic(val.msg)"
                >
                  <i
                    class="el-icon-download"
                    style="color: #fff; font-size: 16px"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message, Messagedd, IMessage, IMessagedd } from "@/api/user";
export default {
  name: "HelloWorld",
  data() {
    return {
      days: 7,
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 20,
        starttime: "",
        endtime: "",
      },
      pop: {
        id: "",
        name: "",
      },
      chat: [],
      code: 0,
      value1: "", // 获取时间
      list: [],
      bodyHeight: document.body.clientHeight || window.innerHeight,
      bodyWidth: document.body.clientWidth || window.innerWidth,
      msg: "",
      isChecked: "",
      status: false,
      height: null,
    };
  },
  mounted() {
    this.handleCommand();
    // this.$nextTick(() => {
    //   this.height = `calc(${this.$refs.pop_ul.clientHeight}px + 73px)`
    // })
  },
  methods: {
    handleCommand(event) {
      let end = new Date();
      let start = new Date(2021, 0, 1);
      if (event) {
        this.days = event;
        start = new Date();
        this.isChecked = true;
        start.setTime(start.getTime() - 3600 * 1000 * 24 * event);
      }
      this.value1 = [start, end];
      this.getlist();
    },
    setPage(e) {
      this.key.page = e;
      this.getlist();
    },
    getlist(a) {
      this.status = false;
      this.key.starttime =
        this.value1[0].getFullYear() +
        "-" +
        (this.value1[0].getMonth() < 9 ? "0" : "") +
        (this.value1[0].getMonth() + 1) +
        "-" +
        (this.value1[0].getDate() < 10 ? "0" : "") +
        this.value1[0].getDate();
      this.key.endtime =
        this.value1[1].getFullYear() +
        "-" +
        (this.value1[1].getMonth() < 9 ? "0" : "") +
        (this.value1[1].getMonth() + 1) +
        "-" +
        (this.value1[1].getDate() < 10 ? "0" : "") +
        this.value1[1].getDate();
      if (a) {
        this.key.page = a;
      }
      this.list = [];
      if (this.$route.params.key === "iMessages") {
        IMessage(this.key).then((adj) => {
          this.list = adj.data.list;
          this.code = adj.data.count;
          if (adj.data.list.length > 0) {
            this.getpop(this.list[0]);
          } else {
            this.pop = {
              id: "",
              name: "",
            };
          }
          this.status = true;
          this.$nextTick(() => {
            this.height = `calc(${this.$refs.pop_ul.clientHeight}px - 79px - 78px)`;
          });
        });
      } else {
        Message(this.key).then((adj) => {
          this.list = adj.data.list;
          this.code = adj.data.count;
          if (adj.data.list.length > 0) {
            this.getpop(this.list[0]);
          } else {
            this.pop = {
              id: "",
              name: "",
            };
          }
          this.status = true;
          this.$nextTick(() => {
            this.height = `calc(${this.$refs.pop_ul.clientHeight}px - 79px - 78px)`;
          });
        });
      }
    },
    getpop(adj) {
      this.pop = adj;
      this.chat = [];
      var listkey = {
        message_list_id: this.pop.id,
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        imit: 99999,
      };

      if (this.$route.params.key === "iMessages") {
        IMessagedd(listkey).then((asd) => {
          console.log(asd.data.list);
          this.chat = asd.data.list;
          this.$nextTick(() => {
            let scrollDom = this.$refs.scrollBar;
            scrollDom.scrollTop = scrollDom.scrollHeight;
          });
        });
      } else {
        Messagedd(listkey).then((asd) => {
          console.log(asd.data.list);
          this.chat = asd.data.list;
          this.$nextTick(() => {
            let scrollDom = this.$refs.scrollBar;
            scrollDom.scrollTop = scrollDom.scrollHeight;
          });
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pop_ul {
  float: left;
  /* width: 385px; */
  width: 419px;
  border-right: 1px solid #e1e3e6;
  background: #fff;
  overflow: hidden;
  height: 100%;
  position: absolute;
  left: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.pop_li {
  width: 85%;
  padding: 20px 30px;
  margin: 0;
  border-bottom: 1px solid #e1e3e6;
}
.pop_li.mr {
  background: rgba(0, 238, 195, 0.1);
}
.pop_li_t {
  font-size: 14px;
  line-height: 20px;
  color: #000927;
  font-weight: 700;
  overflow: hidden;
  text-align: left;
}
.pop_li_t span {
  font-size: 12px;
  line-height: 20px;
  color: #9f9f9f;
  font-weight: 400;
  float: right;
  text-align: right;
}
.pop_li_c {
  font-size: 13px;
  line-height: 20px;
  color: #45484d;
  text-align: left;
}
.mes_a {
  margin: 20px auto;
  overflow: hidden;
}
.mes_a a {
  float: left;
  display: block;
  width: 32px;
  height: 32px;
  border: 1px solid #9f9f9f;
  border-radius: 6px;
  margin-left: 8px;
  color: #9f9f9f;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
}
.mes_a a:first-child {
  margin-left: 0;
}
.mes_a a.mr {
  background: #00eec3;
  color: #000927;
  border-color: #00eec3;
}
.mes_a a img {
  display: block;
  width: 16px;
  height: 16px;
  margin: 8px;
}
#dialog {
  position: fixed;
  top: 60px;
  right: 0;
  background: #fff;
  border-left: 1px solid #e1e3e6;
}
#dialog .name {
  width: 100%;
  height: 78px;
  border-bottom: 1px solid #e1e3e6;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  text-indent: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
#dialog .name .time1 {
  font-size: 13px;
}
#dialog .dialog {
  width: 100%;
  overflow: auto;
}
#dialog .user {
  overflow: hidden;
  margin-top: 20px;
}
#dialog .user_img {
  float: left;
  /* width: 40px;
  height: 40px; */
  border-radius: 20px;
  overflow: hidden;
  margin-left: 20px;
  margin-top: 20px;
}
#dialog .user_img img {
  float: left;
  width: 40px;
  height: 40px;
  display: block;
}
#dialog .user_name {
  float: left;
  overflow: hidden;
  margin-left: 10px;
}
#dialog .user_tit {
  font-size: 14px;
  color: #000927;
  font-weight: 700;
}
#dialog .user_time {
  font-size: 11px;
  color: #9f9f9f;
}
.user_dialog {
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}
.time {
  font-family: Noto Sans;
  font-size: 11px;
  color: #9f9f9f;
  margin: 4px auto 4px 10px;
}
.user_dialog .content {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 0 12px 12px 12px;
  background: #e7e9eb;
  max-width: 600px;
  margin: 4px auto 4px 10px;
  width: auto;
  float: left;
  max-width: 380px;
  word-break: break-all;
  position: relative;
}
/* .user_dialog div {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 0 12px 12px 12px;
  background: #e7e9eb;
  max-width: 360px;
  margin: 4px auto 4px 20px;
  width: auto;
  float: left;
  position: relative;
} */
.user_dialog div img {
  display: block;
  width: 100%;
}
.user_dialog .dow {
  display: block;
  width: 24px;
  height: 24px;
  position: absolute;
  left: 18px;
  bottom: 18px;
  cursor: pointer;
}
#dialog .my {
  overflow: hidden;
  margin-top: 20px;
}
#dialog .my_img {
  float: right;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  /* overflow: hidden; */
  margin-right: 40px;
  margin-top: 20px;
}
#dialog .my_img img {
  float: right;
  width: 40px;
  height: 40px;
  display: block;
}
#dialog .my_name {
  float: right;
  overflow: hidden;
  margin-right: 10px;
}
#dialog .my_tit {
  font-size: 14px;
  color: #000927;
  font-weight: 700;
  text-align: right;
}
#dialog .my_time {
  font-size: 11px;
  color: #9f9f9f;
}
.my_dialog {
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
}
.time {
  font-family: Noto Sans;
  font-size: 11px;
  color: #9f9f9f;
  margin: 4px 10px 4px 10px;
}
.my_dialog .content {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 12px 0 12px 12px;
  background: #00eec3;
  max-width: 600px;
  margin: 4px 10px 4px 10px;
  width: auto;
  float: left;
  max-width: 380px;
  word-break: break-all;
  position: relative;
}
/* .my_dialog div {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  padding: 10px;
  border-radius: 12px 0 12px 12px;

  max-width: 600px;
  margin: 4px 20px 4px auto;
  width: auto;
  float: right;
  max-width: 380px;
  word-break: break-all;
} */
.my_dialog div img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue